<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Can I ship to campus?</h1>
			<p v-if="is_campus_pickup_enabled">
				Yes, you can ship to campus during certain times. Just click on the address dropdown in checkout, choose your campus ship to, and we will
				populate
				the shipping information for you. If you don't see an option, but you have a campus shipping address, you should check with your mailroom to
				make
				sure it's ok to send packages of books first.
			</p>
			<p v-else>
				Sorry but your school does not have campus pickup enabled through our system. If you have a campus shipping address, you should check with your
				mailroom to make sure it's ok to send packages of books first.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "CanShipToCampus",

		components: {
			BaseNavLinks,
		},

		computed: {
			is_campus_pickup_enabled() {
				return this.$globs['institute_info'] && this.$globs['institute_info']['is_campus_pickup_enabled'];
			}
		},
	}
</script>

<style scoped>

</style>